import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React from "react";
import { BASE_API_URL } from "store/Me";
import moment from "moment";
import { AdminTable } from "components/shared/AdminTable";
import { GuestType } from "./AdminGuests";

export default function GuestTemporaryAccess({ guestId }: { guestId: string }) {
  const { data, isError } = useGetGuestTemporaryAccess(guestId);

  if (isError) {
    return <div>There was an error loading temporary access.</div>;
  }

  if (data) {
    return (
      <div>
        <AdminTable aria-label="Guest temporary access" containerClassName="mt-1">
          <thead>
            <tr>
              <th scope="col">Property</th>
              <th scope="col">Unit Number</th>
              <th scope="col">Reason</th>
              <th scope="col">Guest Type</th>
              <th scope="col">Claimed</th>
              <th scope="col">Expires</th>
              <th scope="col">Deleted</th>
            </tr>
          </thead>
          <tbody>
              {data.map((temporaryAccess) => (
                <tr key={temporaryAccess.id}>
                  <td>{temporaryAccess.propertyExternalId}</td>
                  <td>{temporaryAccess.unitNumber}</td>
                  <td>{temporaryAccess.reasonType}</td>
                  <td>{temporaryAccess.guestType}</td>
                  <td>
                    {temporaryAccess.claimedTimestamp
                      ? moment(temporaryAccess.claimedTimestamp).format(
                          "YYYY-MM-DD h:mm A",
                        )
                      : ""}
                  </td>
                  <td>
                    {temporaryAccess.expirationTimestamp
                      ? moment(temporaryAccess.expirationTimestamp).format(
                          "YYYY-MM-DD h:mm A",
                        )
                      : ""}
                  </td>
                  <td>
                    {temporaryAccess.deletedTimestamp
                      ? moment(temporaryAccess.deletedTimestamp).format(
                          "YYYY-MM-DD h:mm A",
                        )
                      : ""}
                  </td>
                </tr>
              ))}
          </tbody>
        </AdminTable>
      </div>
    );
  }

  return <div>loading...</div>;
}

export interface GuestTemporaryAccessResponse {
  id: string;
  guestInviteId: string;
  propertyExternalId: string;
  unitNumber: string | null;
  reasonType: string;
  guestType: GuestType;
  claimedTimestamp: string;
  expirationTimestamp: string;
  deletedTimestamp: string | null;
}

async function getGuestTemporaryAccess(guestId: string) {
  const url = `${BASE_API_URL}/api/guest/${guestId}/temporary-access`;
  const response = await axios.get<GuestTemporaryAccessResponse[]>(url);

  return response.data;
}

function useGetGuestTemporaryAccess(guestId: string) {
  return useQuery({
    queryKey: ["guests", "temporary-access", guestId],
    queryFn: () => getGuestTemporaryAccess(guestId),
  });
}
